import { createContext } from 'react';
import noop from 'lodash/noop';

export const ProjectRestoreContext = createContext(noop);
